/**
 * Generate a random UUID v4. Uses crypto.randomUUID() when available
 * (secure contexts), falls back to a manual implementation for
 * non-secure contexts (e.g., plain HTTP on non-localhost).
 */
export function randomUUID(): string {
  try {
    return crypto.randomUUID();
  } catch {
    // Fallback: randomUUID unavailable in non-secure contexts (plain HTTP)
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  // Set version (4) and variant (1) bits per RFC 4122
  bytes.set([(bytes[6]! & 0x0f) | 0x40], 6);
  bytes.set([(bytes[8]! & 0x3f) | 0x80], 8);
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
